import { Z_INDEX } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import OneSchemaImporter from '@oneschema/react';
import styled from 'styled-components';

export const OneSchemaImporterModal = styled(OneSchemaImporter)`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: ${Z_INDEX.ONE_SCHEMA_MODAL};
`;
